import React, { useState } from 'react';
import UserDirectory from './UserDirectory';
import MarketManager from './MarketManager';
import ServiceMarketMap from './ServiceMarketMap';
import TradeManager from './TradeManager';
import RateSettingsManager from './RateSettingsManager';
import { Users, MapPinned, Map, Wrench, Sliders } from 'lucide-react';

const TABS = [
  { key: 'users', label: 'ROUT Access & Assignments', icon: Users },
  { key: 'markets', label: 'Service Markets', icon: MapPinned },
  { key: 'market-map', label: 'Service Market Map', icon: Map },
  { key: 'trades', label: 'Trade List', icon: Wrench },
  { key: 'rates', label: 'Rate Settings', icon: Sliders },
];

const AdministrationView = () => {
  const [tab, setTab] = useState('users');
  return (
    <div data-testid="administration-view">
      <div className="mb-6">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#8FC93A]">Operations</div>
        <h1 className="text-3xl font-extrabold text-[#0E2A47]">Administration</h1>
        <p className="text-sm text-slate-500 mt-1">Manage internal and client users, roles, hierarchy and service footprints.</p>
      </div>
      <div className="flex gap-2 mb-6 border-b border-gray-200">
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = tab === t.key;
          return (
            <button key={t.key} onClick={() => setTab(t.key)} data-testid={`admin-tab-${t.key}`}
              className={`inline-flex items-center gap-2 px-4 py-2.5 text-sm font-semibold border-b-2 -mb-px transition-colors ${active ? 'border-[#0E2A47] text-[#0E2A47]' : 'border-transparent text-slate-400 hover:text-slate-600'}`}>
              <Icon size={16} /> {t.label}
            </button>
          );
        })}
      </div>
      {tab === 'users' && <UserDirectory />}
      {tab === 'markets' && <MarketManager />}
      {tab === 'market-map' && <ServiceMarketMap />}
      {tab === 'trades' && <TradeManager />}
      {tab === 'rates' && <RateSettingsManager />}
    </div>
  );
};

export default AdministrationView;
